import { recordToJs, getViewFields } from "componentsv2/tools/functions";
import proxy from "api/proxy";

async function getFromId(rec_id, model, layout) {
  const fields = getViewFields(layout, "form");
  const { data } = await proxy.browse(model, [rec_id], fields);
  return recordToJs(data[0], layout.fields);
}

export { getFromId };
